module.exports = __webpack_public_path__ + "img/icon_search_green.e27ac63.svg";